import { isStorageOperationError } from '../../services/azureStorageApi';

/**
 * The line a refused create / delete table shows (S4 review F, F9): what failed, then the typed IPC reason the
 * main process gave (read-only, outside the attachment scope, already exists, not found, network …). An error
 * without a message keeps the generic line. A PERMISSION refusal carries main's own explanation (R10,
 * `electron/azure-storage/tables/tableAdminErrors.ts`: tables/write or tables/delete for Entra, the account-SAS
 * resource type and permission, a table's own SAS that can do neither), shown as it is (Codex merge-C C-N01) — the
 * renderer used to swap a SAS explanation for a generic sentence.
 */
export function tableAdminFailureText(verb: 'created' | 'deleted', error: unknown): string {
  const reason = isStorageOperationError(error) || error instanceof Error ? error.message.trim() : '';
  return reason ? `The table could not be ${verb}. ${reason}` : `The table could not be ${verb}.`;
}
